import { Link } from "react-router-dom";
import { Head } from "vite-react-ssg";
import { t as getFixedT } from "@/i18n";
import "./NotFoundPage.css";

/**
 * Generic catch-all 404 (path: '*' in src/app/routes.tsx). Not locale-prefixed — a mistyped or
 * dead link could arrive in either language — so it shows both AR and EN copy and links back to
 * both locale homes, defaulting the document direction to the site's primary language (Arabic).
 */
export function NotFoundPage() {
  const tAr = getFixedT("ar");
  const tEn = getFixedT("en");

  return (
    <>
      <Head>
        <html lang="ar" dir="rtl" />
        <title>
          404 — {tAr("notFound.title")} / {tEn("notFound.title")}
        </title>
        <meta name="robots" content="noindex" />
      </Head>
      <main className="fa-not-found">
        <p className="fa-not-found__code">404</p>
        <section lang="ar" dir="rtl" className="fa-not-found__block">
          <h1>{tAr("notFound.title")}</h1>
          <p>{tAr("notFound.body")}</p>
          <Link to="/ar">{tAr("notFound.backHome")}</Link>
        </section>
        <section lang="en" dir="ltr" className="fa-not-found__block">
          <h1>{tEn("notFound.title")}</h1>
          <p>{tEn("notFound.body")}</p>
          <Link to="/en">{tEn("notFound.backHome")}</Link>
        </section>
      </main>
    </>
  );
}
